<template>
  <div class="ba-page">
    <div class="ba-header">
      <div>
        <h2 class="ba-title"><feather-icon icon="BookOpenIcon" size="22" class="mr-75" />Blog</h2>
        <p class="ba-sub">Gerencie os artigos do blog VSLBooster</p>
      </div>
      <button class="ba-btn ba-btn--primary" @click="$router.push({ name: 'admin-blog-editor' })">
        <feather-icon icon="PlusIcon" size="14" class="mr-50" />Novo Artigo
      </button>
    </div>

    <div class="ba-filters">
      <button class="ba-filter" :class="{ 'ba-filter--active': statusFilter === '' }" @click="statusFilter = ''; fetch()">Todos</button>
      <button class="ba-filter" :class="{ 'ba-filter--active': statusFilter === 'published' }" @click="statusFilter = 'published'; fetch()">Publicados</button>
      <button class="ba-filter" :class="{ 'ba-filter--active': statusFilter === 'draft' }" @click="statusFilter = 'draft'; fetch()">Rascunhos</button>
    </div>

    <div v-if="fetchError" class="ba-alert">
      <feather-icon icon="AlertCircleIcon" size="14" class="mr-50" />
      <span>{{ fetchError }}</span>
      <button class="ba-alert__retry" @click="fetch">Tentar novamente</button>
    </div>

    <div v-if="loading" class="ba-loading">Carregando...</div>

    <div v-else-if="!posts.length" class="ba-empty">
      <feather-icon icon="FileTextIcon" size="40" />
      <p>Nenhum artigo encontrado</p>
      <button class="ba-btn ba-btn--primary" @click="$router.push({ name: 'admin-blog-editor' })">Criar primeiro artigo</button>
    </div>

    <div v-else class="ba-table-wrap">
      <table class="ba-table">
        <thead>
          <tr>
            <th>Artigo</th>
            <th>Categoria</th>
            <th>Status</th>
            <th>Data</th>
            <th>Acoes</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="post in posts" :key="post.id">
            <td>
              <div class="ba-post-cell">
                <img v-if="post.cover_image" :src="post.cover_image" class="ba-post-thumb" />
                <div v-else class="ba-post-thumb ba-post-thumb--empty"><feather-icon icon="ImageIcon" size="16" /></div>
                <div>
                  <div class="ba-post-title">{{ post.title }}</div>
                  <div class="ba-post-slug">/blog/{{ post.slug }}</div>
                </div>
              </div>
            </td>
            <td><span v-if="post.category_name" class="ba-cat-badge" :style="{ background: post.category_color }">{{ post.category_name }}</span></td>
            <td>
              <span class="ba-status" :class="'ba-status--' + post.status">
                {{ post.status === 'published' ? 'Publicado' : post.status === 'archived' ? 'Arquivado' : 'Rascunho' }}
              </span>
            </td>
            <td class="ba-date">{{ formatDate(post.published_at || post.created_at) }}</td>
            <td>
              <div class="ba-actions">
                <button class="ba-action" @click="$router.push({ name: 'admin-blog-editor', params: { id: post.id } })" title="Editar">
                  <feather-icon icon="EditIcon" size="14" />
                </button>
                <button class="ba-action ba-action--danger" @click="deletePost(post)" title="Excluir">
                  <feather-icon icon="TrashIcon" size="14" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogAdmin',
  data() {
    return { posts: [], loading: true, statusFilter: '', fetchError: '' }
  },
  mounted() { this.fetch() },
  methods: {
    api(method, url, body) {
      const token = localStorage.getItem('accessToken') || localStorage.getItem('token')
      const opts = { baseURL: '', headers: { Authorization: `Bearer ${token}` } }
      if (method === 'get' || method === 'delete') return this.$http[method](url, opts)
      return this.$http[method](url, body, opts)
    },
    async fetch() {
      this.loading = true
      this.fetchError = ''
      try {
        const limit = 100
        const allPosts = []
        let page = 1
        let total = Infinity

        while (allPosts.length < total) {
          let url = `/api/dkbackend/blog/admin/posts?limit=${limit}&page=${page}`
          if (this.statusFilter) url += `&status=${this.statusFilter}`
          const { data } = await this.api('get', url)
          const batch = (data && data.posts) || []
          total = Number((data && data.total) || batch.length || 0)
          allPosts.push(...batch)
          if (!batch.length || batch.length < limit) break
          page += 1
        }

        this.posts = allPosts
      } catch (e) {
        console.error('[blog-admin]', e)
        this.posts = []
        const status = e && e.response && e.response.status
        if (status === 401) {
          await this.fetchPublishedFallback()
        } else {
          this.fetchError = 'Não foi possível carregar os posts agora.'
        }
      }
      this.loading = false
    },
    async fetchPublishedFallback() {
      try {
        const limit = 50
        let page = 1
        let totalPages = 1
        const posts = []
        do {
          const resp = await fetch(`/api/dkbackend/blog/posts?page=${page}&limit=${limit}`)
          const data = await resp.json()
          const batch = (data && data.posts) || []
          posts.push(...batch.map(p => ({ ...p, status: 'published' })))
          totalPages = Number((data && data.pages) || 1)
          page += 1
        } while (page <= totalPages)
        this.posts = posts
        this.fetchError = posts.length
          ? ''
          : 'Sessão admin expirada e nenhum artigo publicado foi encontrado.'
      } catch (err) {
        console.error('[blog-admin] fallback', err)
        this.fetchError = 'Sua sessão expirou. Faça login novamente para ver os posts.'
      }
    },
    async deletePost(post) {
      if (!confirm(`Excluir "${post.title}"?`)) return
      try {
        await this.api('delete', `/api/dkbackend/blog/admin/posts/${post.id}`)
        this.fetch()
        this.$message({ type: 'success', message: 'Artigo excluido' })
      } catch {}
    },
    formatDate(d) {
      if (!d) return '-'
      return new Date(d).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' })
    },
  },
}
</script>

<style lang="scss" scoped>
$orange: #E86A10;
.ba-page { padding: 0; }
.ba-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 24px; }
.ba-title { display: flex; align-items: center; font-size: 22px; font-weight: 800; color: #e2e8f0; margin: 0; }
.ba-sub { font-size: 13.5px; color: rgba(255,255,255,0.4); margin: 4px 0 0; }
.ba-btn { padding: 10px 20px; border-radius: 8px; font-size: 13px; font-weight: 700; cursor: pointer; border: none; font-family: inherit; display: inline-flex; align-items: center; &--primary { background: $orange; color: #fff; } }

.ba-filters { display: flex; gap: 6px; margin-bottom: 20px; }
.ba-filter { padding: 7px 16px; border-radius: 8px; border: 1.5px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.05); font-size: 13px; font-weight: 600; color: rgba(255,255,255,0.55); cursor: pointer; font-family: inherit; &--active { background: $orange; border-color: $orange; color: #fff; } }

.ba-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
  border-radius: 10px;
  border: 1px solid rgba(251,191,36,0.35);
  background: rgba(251,191,36,0.1);
  color: #fbbf24;
  font-size: 12px;
  font-weight: 600;
}
.ba-alert__retry {
  margin-left: auto;
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.2);
  color: #fff;
  border-radius: 8px;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.ba-loading, .ba-empty { text-align: center; padding: 60px; color: rgba(255,255,255,0.3); }
.ba-table-wrap { overflow-x: auto; }
.ba-table { width: 100%; border-collapse: collapse; font-size: 13.5px; }
.ba-table th { text-align: left; padding: 12px 16px; font-size: 11px; font-weight: 700; color: rgba(255,255,255,0.4); text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 2px solid rgba(255,255,255,0.08); }
.ba-table td { padding: 14px 16px; border-bottom: 1px solid rgba(255,255,255,0.05); color: #cbd5e1; }

.ba-post-cell { display: flex; align-items: center; gap: 12px; }
.ba-post-thumb { width: 56px; height: 36px; border-radius: 6px; object-fit: cover; flex-shrink: 0; &--empty { background: rgba(255,255,255,0.06); display: flex; align-items: center; justify-content: center; color: rgba(255,255,255,0.2); } }
.ba-post-title { font-weight: 700; color: #e2e8f0; }
.ba-post-slug { font-size: 11px; color: rgba(255,255,255,0.35); }

.ba-cat-badge { padding: 3px 10px; border-radius: 5px; font-size: 11px; font-weight: 700; color: #fff; }
.ba-status { padding: 3px 10px; border-radius: 5px; font-size: 11px; font-weight: 700; &--published { background: rgba(16,185,129,0.18); color: #34d399; } &--draft { background: rgba(251,191,36,0.18); color: #fbbf24; } &--archived { background: rgba(255,255,255,0.08); color: rgba(255,255,255,0.45); } }
.ba-date { font-size: 12px; color: rgba(255,255,255,0.35); white-space: nowrap; }

.ba-actions { display: flex; gap: 6px; }
.ba-action { width: 32px; height: 32px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.05); cursor: pointer; display: flex; align-items: center; justify-content: center; color: rgba(255,255,255,0.45); &:hover { border-color: $orange; color: $orange; } &--danger:hover { border-color: #f87171; color: #f87171; } }
</style>
